






















import Vue from 'vue'

// Icons
import GoogleDriveIcon from './img/attachment-google-drive.svg'
import PdfIcon from './img/attachment-pdf.svg'
import ExcelIcon from './img/attachment-excel.svg'
import ImageIcon from './img/attachment-image.svg'
import WordIcon from './img/attachment-word.svg'
import ZipIcon from './img/attachment-zip.svg'
import AttachmentIcon from './img/attachment.svg'
import { IAttachment } from '@/types/data-objects/attachments'
import { IDynamicObject } from '@/types'

export default Vue.extend({
  name: 'AttachmentsList',

  props: {
    attachments: {
      type: Array as () => IAttachment[],
      required: true,
    },
  },

  computed: {
    hasAttachments(): Boolean {
      return this.attachments.length > 0
    },
    fileTypesIcons(): IDynamicObject {
      return {
        googleDrive: GoogleDriveIcon,
        file_pdf: PdfIcon,
        file_img: ImageIcon,
        file_doc: WordIcon,
        file_xls: ExcelIcon,
        file_zip: ZipIcon,
        file: AttachmentIcon,
      }
    },
  },

  methods: {
    getFileTypeIcon(type: string): string {
      return this.fileTypesIcons[type]
    },

    /**
     * Remove extension from filename
     */
    getName(name: string): string {
      if (name.includes('.')) {
        return name
          .split('.')
          .slice(0, -1)
          .join('.')
      }
      return name
    },

    getFileExtension(name: string): string {
      const re = /(?:\.([^.]+))?$/
      const extension = re.exec(name)[1]

      return extension ? `${extension}` : ''
    },
  },
})
